import React from "react";
import moment from "moment";
import {
  getField,
  deserializeField,
  formatDate,
} from "../../util/DynamicItemUtils";

import SubsequentActions from "../SubsequentActions";

export default function EnforcementDocument({ item }: any) {
  const dateParsingFormat = "YYYY-MM-DDTHH:mm:ssZ";
  const effectiveDateFormat =
    getField(item, "effectivedate") &&
    formatDate(getField(item, "effectivedate"));
  const showEffectiveDate = getField(item, "hideeffectivedate") === "False";
  const boardActionDateFormat =
    getField(item, "boardactiondate") &&
    formatDate(getField(item, "boardactiondate"));
  const releaseDateFormat =
    getField(item, "releasedate") && formatDate(getField(item, "releasedate"));

  const sanctionsCancelled = getField(item, "sanctionscancelled") === "True";

  var getSequentialDocuments = function (field) {
    if (item && item.Document && item.Document.hasOwnProperty(field)) {
      var data = item.Document[field];

      if (data.length) {
        try {
          data = data.map((i) => JSON.parse(i));
        } catch (e) {
          console.error(e);
        }
      }

      return data;
    }
  };

  return (
    <div>
      <p className="lead-text-lt">{getField(item, "contenttypelabel")}</p>
      {getField(item, "enforcementorderdocument") && (
        <h3>
          <a
            href={
              deserializeField(item, "enforcementorderdocument")[0].mediaUrl
            }
            download
            target="_blank"
          >
            {getField(item, "title")}
          </a>
        </h3>
      )}
      <div className="hawk-row inline">
        {getField(item, "enforcementordertypes") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Types</div>
            <div className="lead-text-st">
              {getField(item, "enforcementordertypes")}
            </div>
          </div>
        )}
        {getField(item, "country") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Country</div>
            <div className="lead-text-st">{getField(item, "country")}</div>
          </div>
        )}
        {showEffectiveDate && getField(item, "effectivedate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">
              {sanctionsCancelled ? "Sanctions cancelled" : "Effective date"}
            </div>
            <div className="lead-text-st">
              {moment(
                getField(item, "effectivedate"),
                dateParsingFormat
              ).format(effectiveDateFormat)}
            </div>
          </div>
        )}
        {getField(item, "boardactiondate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Board Action date</div>
            <div className="lead-text-st">
              {moment(
                getField(item, "boardactiondate"),
                dateParsingFormat
              ).format(boardActionDateFormat)}
            </div>
          </div>
        )}
        {getField(item, "releasedate") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Release date</div>
            <div className="lead-text-st">
              {moment(getField(item, "releasedate"), dateParsingFormat).format(
                releaseDateFormat
              )}
            </div>
          </div>
        )}
      </div>
      {getField(item, "practicelimitationexpirationnotice") && (
        <div className="hawk-row">
          <div className="hawk-column">
            <div className="lead-text-lt">
              Practice Limitation Expiration Notice
            </div>
            <div className="lead-text-st">
              {getField(item, "practicelimitationexpirationnotice")}
            </div>
          </div>
        </div>
      )}
      <div className="hawk-row inline">
        {deserializeField(item, "enforcementorderdocument") && (
          <div className="hawk-column">
            <a
              href={
                deserializeField(item, "enforcementorderdocument")[0].mediaUrl
              }
              download
              className="hawk-download-pdf"
              target="_blank"
            >
              Download PDF
            </a>
          </div>
        )}

        <div className="hawk-column">
          <SubsequentActions
            items={getSequentialDocuments("subsequentactions")}
          />
        </div>
      </div>
    </div>
  );
}
